window.roundupInitializer=function(){
  var roundUpVariantId = window.ROUNDUP_VARIANT_ID;
  window.roundupChecking = false;
  
  function afterFinish(target) {
    var $target = jQuery(target);
    if ($target.attr('href')) {
      window.location.href = $target.attr('href');
      return;
    }
    
    $target.trigger('click');
  }
  
  function handleRoundUp(ev) {
    if (window.roundupChecking) return true;
    console.log(ev.target);
    console.log('checkout clicked...');
    ev.preventDefault();
    ev.stopPropagation();
    window.roundupChecking = true;
    var addRoundUp = jQuery('.round_up_checkbox').prop('checked');
    var quantity = parseInt(jQuery('.roundup_donation_amount').val());

    console.log("addRoundUp: " + addRoundUp);
    console.log("donation amount: " + quantity);
    

      if (addRoundUp) {
        var params = {
            type		: 'POST',
            url			: '/cart/add.js',
            async: false,
            data		: 'quantity=1' + '&id=' + roundUpVariantId,
            dataType	: 'json',
          success: function() {
            console.log('add success...');
            afterFinish(ev.target);
          }
        };
        jQuery.ajax(params);
        console.log("add roundup prod");
      }
      if (!addRoundUp){
        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            async: false,
            data: "updates["+roundUpVariantId+"]=0",
            dataType: 'json',
          success: function() {
            console.log('update/remove success...');
            afterFinish(ev.target);
          }
        });
        console.log("update/remove roundup prod");
      }
    
    return false;
  }
  
  jQuery('body').on('click', 'input[name="checkout"]', handleRoundUp);
}